<p-dialog [(visible)]="isVisible" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
    styleClass="googledrive-modal-dialog" (onHide)="closeModal()">

    <!-- Custom Header Template -->
    <ng-template pTemplate="header">
        <div class="modal-header">
            <h5 class="modal-title" id="googleDriveModalLabel">
                <img src="assets/img/g-drive.png" alt="Google Drive" width="48" height="40">
                Select File from Google Drive
            </h5>
        </div>
    </ng-template>

    <div class="googledrive-modal-content">

        <!-- Loading State -->
        <div *ngIf="loading" class="loading-container">
            <div class="loading-content">
                <i class="pi pi-spin pi-spinner loading-spinner"></i>
                <p class="loading-message">{{ signingIn ? 'Connecting to Google Drive...' : 'Loading your files...' }}
                </p>
            </div>
        </div>

        <!-- Main Content -->
        <div *ngIf="!loading" class="modal-body">

            <!-- Sign In Section -->
            <div *ngIf="!isSignedIn" class="info-section">
                <div class="service-header">
                    <img src="assets/img/g-drive.png" alt="Google Drive" class="service-icon">
                    <div class="service-info">
                        <h6 class="service-title">Google Drive</h6>
                        <p class="service-description">Connect to Google Drive</p>
                        <p class="service-description">Sign in to access your files from Google Drive</p>
                    </div>
                </div>
            </div>

            <!-- File Type Info (when not signed in) -->
            <div *ngIf="!isSignedIn" class="file-info-section">
                <div class="supported-formats">
                    <!-- <small class="format-label">Supported formats:</small> -->
                    <small class="format-label">Supported format:</small>
                    <div class="format-badges">
                        <span class="format-badge">PDF</span>
                        <!-- <span class="format-badge">DOC</span>
            <span class="format-badge">DOCX</span> -->
                    </div>
                </div>
                <div class="size-limit">
                    <small class="size-label">Maximum file size: <strong>10 MB</strong></small>
                </div>
            </div>

            <!-- Instructions (when not signed in) -->
            <div *ngIf="!isSignedIn" class="instructions-section">
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Click "Sign in to Google Drive" to authenticate</span>
                </div>
                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Browse and select your PDF document</span>
                </div>

                <div class="instruction-item">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>Click the "Use Selected File" button</span>
                </div>

            </div>

            <!-- Files Browser Section (when signed in) -->
            <div *ngIf="isSignedIn">
                <div class="files-header">
                    <h6 class="files-title">Your Google Drive Files</h6>
                    <p-button label="Sign Out from Google Drive" icon="pi pi-sign-out" (onClick)="signOut()"
                       >
                    </p-button>
                </div>

                <!-- Files List -->
                <div *ngIf="files.length > 0" class="files-container">
                    <div class="files-grid">
                        <div *ngFor="let file of files" class="file-item-wrapper">
                            <div class="file-item" [class.selected]="selectedFile?.id === file.id"
                                (click)="selectFile(file)">
                                <div class="file-content">
                                    <div class="file-icon-wrapper">
                                        <i class="pi pi-file-pdf file-icon pdf-icon"
                                            *ngIf="file.mimeType.includes('pdf')"></i>
                                        <i class="pi pi-file-word file-icon word-icon"
                                            *ngIf="file.mimeType.includes('word') || file.mimeType.includes('document')"></i>
                                    </div>
                                    <div class="file-info">
                                        <h6 class="file-name">{{ file.name }}</h6>
                                        <small class="file-meta">
                                            {{ formatFileSize(+file.size) }} • {{ formatDate(file.modifiedTime) }}
                                        </small>
                                    </div>
                                    <div class="file-selector">
                                        <i class="pi pi-check-circle selected-icon"
                                            *ngIf="selectedFile?.id === file.id"></i>
                                        <i class="pi pi-circle-off unselected-icon"
                                            *ngIf="selectedFile?.id !== file.id"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- No Files -->
                <div *ngIf="files.length === 0" class="no-files-container">
                    <div class="no-files-content">
                        <i class="pi pi-folder-open no-files-icon"></i>
                        <h6 class="no-files-title">No documents found</h6>
                        <p class="no-files-message">No PDF or Word documents found in your Google Drive</p>
                    </div>
                </div>
            </div>

            <!-- Error Display -->
            <div *ngIf="false" class="error-section">
                <div class="error-message">
                    <i class="pi pi-exclamation-triangle error-icon"></i>
                    <span>Error message would appear here</span>
                </div>
            </div>

        </div>
    </div>

    <!-- Footer -->
    <ng-template pTemplate="footer">
        <div class="modal-footer" style="border-top: 1px solid #e1e5e9;padding-top: 1rem;">
            <p-button label="Cancel" icon="pi pi-times" (onClick)="closeModal()">
            </p-button>

            <!-- Sign In Button (when not signed in) -->
            <p-button *ngIf="!isSignedIn" label="Sign In to Google Drive" icon="pi pi-google"
                (onClick)="signInToGoogleDrive()" >
            </p-button>

            <!-- Use File Button (when signed in) -->
            <p-button *ngIf="isSignedIn" label="Use Selected File" icon="pi pi-check" (onClick)="downloadAndUseFile()"
                [loading]="downloading" styleClass="p-button-primary">
            </p-button>
        </div>
    </ng-template>

</p-dialog>

<!-- Global Loading Overlay -->
<!-- <div *ngIf="loading || signingIn" class="global-loading-overlay">
    <div class="loading-backdrop"></div>
</div> -->